import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "react-modal";
import CreateRequestForm from "../components/modals/request modals/CreateRequestForm";
import MoveToPurOrderForm from "../components/modals/request modals/MoveToPurOrderForm";
import EditRequest from '../components/modals/request modals/EditRequest';
import CreateSaleOrderForm from "../components/modals/request modals/CreateSaleOrder";
import RequestDetails from '../components/modals/request modals/ReqDetailsModal';
import { useAuthContext } from '../hooks/useAuthContext';

Modal.setAppElement('#root'); //needed where ever there is a Modal to prevent console warning


const RequestsDetails = () => {
  const [watches, setWatches] = useState(); //watches variable will hold all watch requests returned from API call to DB
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [purOrderModalIsOpen, setPurOrderModalIsOpen] = useState(false);
  const [openEditRequestModal, setOpenEditRequestModal] = useState(false);
  const [openCreateSOForm, setOpenCreateSOForm] = useState(false);
  const [selectedWatchId, setSelectedWatchId] = useState('');
  const [selectedWatch, setSelectedWatch] = useState('');
  const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook

    //get screensize
    const getScreenSize = () => {
      const width = window.innerWidth;
      if (width < 500) return 'xsmall';
      if (width >= 500 && width < 800) return 'small';
      if (width >= 800 && width < 1440) return 'medium';
      return 'large';
    };
    const [screenSize, setScreenSize] = useState(getScreenSize());


  useEffect(() => {
    const getRequests = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_SERVER_URL + "/api/watchRequests",
          {headers: {'Authorization': `Bearer ${user.token}`}}
        ); //get all active watch requests
        setWatches(response.data);
      } catch (error) {
        console.error("Failed to get all watch requests: " + error.message);
      }
    };

    if (user) {
      getRequests();
    }

    const handleResize = () => {
      setScreenSize(getScreenSize());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [user]);



  function openModal() {
    setIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }
  function closeModal() {
    setIsOpen(false);
  }

  const openDetails = (watch) => {
    setSelectedWatch(watch);
    setOpenDetailsModal(true);
  }
  const closeDetails = () => {
    setOpenDetailsModal(false);
  }

  const openPurOrderModal = (id) => {
    setSelectedWatchId(id);
    setPurOrderModalIsOpen(true);
  }
  const closePurOrderModal = () => {
    setPurOrderModalIsOpen(false);
  }

  const editRequest = (watch) => {
    setSelectedWatch(watch); //watch here is an object containing all the watch properties
    //set openEditRequestModal to true so that it opens
    setOpenEditRequestModal(true);
  }
  const closeEditRequestModal = () => {
    setOpenEditRequestModal(false);
  }

  const createSaleOrder = (watch) => {
    setSelectedWatch(watch);
    setOpenCreateSOForm(true);
  }
  const closeCreateSaleOrder = () => {
    setOpenCreateSOForm(false);
  }

  const deleteRequest = async (id) => {
    try {
        const response = await axios.delete(
          process.env.REACT_APP_SERVER_URL + '/api/watchRequests/deleteRequest/' + id, 
          {headers: {'Authorization': `Bearer ${user.token}`}}
        );
        console.log('Deleted request: ' + response.data);
        setWatches(watches.filter((watch) => watch._id !== id));
    } catch (e) {
        console.log(e.response.data.error);
    }  
  }



  return (
    <div className="requests-details">
      <div className="top-banner">
        <h2>Requests</h2>
        <button className="btn btn-light" onClick={openModal}><i className="fa-regular fa-plus"></i>New Request</button>
      </div>

      {/* Create Request Modal */}
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        contentLabel="Create Request"
      >
        <div className="modal-header">
            <h2>Create Request</h2>
            <button className="btn btn-light" onClick={closeModal}>Close</button>
        </div>
        <CreateRequestForm />
      </Modal>

      {/* Open Details Modal */}
      <Modal
        isOpen={openDetailsModal}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeDetails}
        contentLabel="Create Request"
      >
        <div className="modal-header">
            <h2>Request Details</h2>
            <button className="btn btn-light" onClick={closeDetails}>Close</button>
        </div>
        <RequestDetails watch={selectedWatch}/>
      </Modal>

      {/* Create PO Modal */}
      <Modal
        isOpen={purOrderModalIsOpen}
        onRequestClose={closePurOrderModal}
        contentLabel="Create Purchase Order"
      >
        <div className="modal-header">
            <h2>Create Purchase Order</h2>
            <button className="btn btn-light" onClick={closePurOrderModal}>Close</button>
        </div>
        <MoveToPurOrderForm watchId={selectedWatchId} />
      </Modal>

      {/* Edit Request Modal */}
      <Modal
        isOpen={openEditRequestModal}
        onRequestClose={closeEditRequestModal}
        contentLabel="Edit Request"
      >
        <div className="modal-header">
            <h2>Edit Request</h2>
            <button className="btn btn-light" onClick={closeEditRequestModal}>Close</button>
        </div>
        <EditRequest watch={selectedWatch} />
      </Modal>

      {/* Create sale order */}
      <Modal
        isOpen={openCreateSOForm}
        onRequestClose={closeCreateSaleOrder}
        contentLabel="Create Sale Order"
      >
        <div className="modal-header">
            <h2>Create Sale Order</h2>
            <button className="btn btn-light" onClick={closeCreateSaleOrder}>Close</button>
        </div>
        <CreateSaleOrderForm watch={selectedWatch} />
      </Modal>

      <table className="detailsTable table">
        <thead>
          <tr>
            <th>Details</th>
            {screenSize === 'large' && <th>Request Date</th>}
            <th>Customer</th>
            {screenSize === 'large' && <th>Brand</th>}
            <th>Model</th>
            {screenSize === 'large' && <th>Year</th>}
            {screenSize === 'large' && <th>Condition</th>}
            {screenSize !== 'small' && screenSize !== 'xsmall' && <th>Box</th>}
            {screenSize !== 'small' && screenSize !== 'xsmall' && <th>Papers</th>}
            {screenSize !== 'small' && screenSize !== 'xsmall' && <th>Customer Quote</th>}
            {screenSize === 'large' && <th>Watch Status</th>}
            <th>Create P.O.</th>
            <th>Create S.O.</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {watches &&
            watches.map((watch) => (
              <tr key={watch._id}>
                <td><button className='btn' onClick={() => openDetails(watch)}><i className="fa-regular fa-eye"></i></button></td>
                {screenSize === 'large' && <td>{watch.request.reqDate.slice(0, 10)}</td>}
                <td>{watch.request.customer}</td>
                {screenSize === 'large' && <td>{watch.brand}</td>}
                <td>{watch.model}</td>
                {screenSize === 'large' && <td>{watch.year}</td>}
                {screenSize === 'large' && <td>{watch.condition}</td>}
                {/* circle-xmark or circle-check based on boolean value for box/papers */}
                {screenSize !== 'small' && screenSize !== 'xsmall' && 
                  <td>
                    <i
                      className={
                        watch.box
                          ? "fa-solid fa-circle-check"
                          : "fa-regular fa-circle-xmark"
                      }
                    ></i>
                  </td>
                }
                {screenSize !== 'small' && screenSize !== 'xsmall' && 
                  <td>
                    <i
                      className={
                        watch.papers
                          ? "fa-solid fa-circle-check"
                          : "fa-regular fa-circle-xmark"
                      }
                    ></i>
                  </td>
                }
                {screenSize !== 'small' && screenSize !== 'xsmall' && <td>${watch.request.reqQuote}</td>}
                {screenSize === 'large' && <td>{watch.status}</td>}
                <td>{watch.status !== "Purchased" && watch.status !== "Sold" ? <button className='btn' onClick={() => openPurOrderModal(watch._id)}><i className="fa-solid fa-cart-shopping"></i></button> : ''}</td>
                <td>{watch.status !== "Sold" ? <button className='btn' onClick={() => createSaleOrder(watch)}><i className="fa-solid fa-money-bill"></i></button> : ''}</td>
                <td><button className='btn' onClick={() => editRequest(watch)}><i className="fa-solid fa-pen"></i></button></td>
                <td><button className='btn' onClick={user ? () => deleteRequest(watch._id) : null}><i className="fa-regular fa-trash-can"></i></button></td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default RequestsDetails;
